import './index.css';
import Fab from '@mui/material/Fab';
import View from '../view';
import useTheme from '../../utilities/hooks/theme';
import { BsFillChatDotsFill } from 'react-icons/bs';
import { CSSProperties } from 'react';
import React from 'react';
// import useFreshBot from './useFreshBot';
//import { openChat } from '../../utilities/helper';

interface Props {
  style?: CSSProperties;
  isBot?: boolean;
}
declare const window: any;
// const ChatFloatBtn = ({ style = {}, isBot = true }: Props) => {
const ChatFloatBtn = ({ style = {} }: Props) => {
  const { AuthTheme: theme } = useTheme();

  // useFreshBot();

  const onPressOpenChat = () => {
    const appId = process.env.REACT_APP_APP_ID;
    if (appId === 'iGamio-dev') {
      const botElem: any = document.getElementById('mobile-chat-container');
      botElem?.click();
      // openChat();
    } else {
      if (window?.fcWidget?.isOpen()) window?.fcWidget?.close();
      else window?.fcWidget?.open();
    }
  };

  const chatFabBtn = {
    backgroundColor: theme.chatFloatBtnBG,
    color: theme.chatFloatBtnTitle
  };

  return (
    <View onPress={onPressOpenChat} style={style} className="chat-float-container">
      <Fab style={chatFabBtn}>
        <BsFillChatDotsFill color={theme.dashboardFloatBtnIcon} size={30} />
      </Fab>
    </View>
  );
};

export default React.memo(ChatFloatBtn);
